import { useEffect, useRef } from "react";
import gsap from "gsap";
import duck from "../../assets/duck.png";
import ripple from "../../assets/duck1.png";
import duckHover from "../../assets/duck1.png";

const RubberDuckCursor = () => {
  const duckRef = useRef(null);
  const mouse = useRef({ x: window.innerWidth / 3, y: window.innerHeight / 3 });
  const pos = useRef({ x: mouse.current.x, y: mouse.current.y });
  const lastMove = useRef(Date.now());

useEffect(() => {
  if ("ontouchstart" in window) return;

  const onMove = (e) => {
    mouse.current.x = e.clientX;
    mouse.current.y = e.clientY;
    lastMove.current = Date.now();

    spawnRipple(e.clientX, e.clientY);
  };

  const onHover = (e) => {
    const target = e.target;

    if (
      target.closest("a, button, input, textarea, select, [role='button']")
    ) {
      if (duckRef.current) {
        duckRef.current.src = duckHover;
      }
    }
  };

  const onOut = () => {
    if (duckRef.current) {
      duckRef.current.src = duck;
    }
  };

  window.addEventListener("mousemove", onMove);
  window.addEventListener("mouseover", onHover);
  window.addEventListener("mouseout", onOut);

  const animate = () => {
    const dx = mouse.current.x - pos.current.x;
    const dy = mouse.current.y - pos.current.y;

    pos.current.x += dx * 0.12;
    pos.current.y += dy * 0.12;

    if (duckRef.current) {
      gsap.set(duckRef.current, {
        x: pos.current.x,
        y: pos.current.y,
      });
    }

    requestAnimationFrame(animate);
  };

  animate();

  return () => {
    window.removeEventListener("mousemove", onMove);
    window.removeEventListener("mouseover", onHover);
    window.removeEventListener("mouseout", onOut);
  };
}, []);


  const spawnRipple = (x, y) => {
    // Stop trail if mouse hasn't moved recently
    if (Date.now() - lastMove.current > 80) return;

    const el = document.createElement("img");
    el.src = ripple;
    el.style.position = "fixed";
    el.style.left = "0";
    el.style.top = "0";
    el.style.width = "20px";
    el.style.height = "20px";
    el.style.pointerEvents = "none";
    el.style.zIndex = 9998;

    document.body.appendChild(el);

    gsap.set(el, {
      x: x - 10,
      y: y - 10,
      opacity: 0.6,
      scale: 0.5,
    });

    gsap.to(el, {
      opacity: 0,
      scale: 1.6,
      duration: 0.8,
      ease: "power1.out",
      onComplete: () => el.remove(),
    });
  };

  return (
    <img
      ref={duckRef}
      src={duck}
      alt="rubber duck cursor"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: 30,
        height: 30,
        pointerEvents: "none",
        zIndex: 9999,
        transform: "translate(-50%, -50%)",
      }}
    />
  );
};

export default RubberDuckCursor;
